import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';


import { showLoading, hideLoading } from '../../../../store/app';
import { toastr } from '../../../../components/CustomToast';
import WebAPIClient, {
  errorResponseToastr,
} from '../../../../api/_energytracer';

export default function BenchmarkResources() {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const [orgId, setOrgId] = useState(null);

  const [resourceOption, setResourceOption] = useState('building')
  const [resourceId, setResourceId] = useState(null);

  const [resourceOption2, setResourceOption2] = useState('building')
  const [resourceId2, setResourceId2] = useState(null);

  const handleLoading = (loading) => {
    if (loading) {
      setIsLoading(true);
      dispatch(showLoading());
    } else {
      setIsLoading(false);
      dispatch(hideLoading());
    }
  };



  const handleCreateOrg = async () => {
    handleLoading(true);
    let url = 'veregy_benchmarking/create_resource';
    let payload = { 'resource_type': 'organization', 'resource_id': orgId }

    try {
      await new WebAPIClient().POST(url, payload);
      toastr.success({
        title: 'Organization Created',
      });
    } catch (err) {
      errorResponseToastr(err);
    } finally {
      handleLoading(false);
      dispatch(hideLoading());
    }
  };

  const handleCreateResource = async () => {
    handleLoading(true);
    let url = 'veregy_benchmarking/create_resource';
    let payload = { 'resource_type': resourceOption, 'resource_id': resourceId }

    try {
      await new WebAPIClient().POST(url, payload);
      toastr.success({
        title: 'Building(s) Created',
      });
    } catch (err) {
      errorResponseToastr(err);
    } finally {
      handleLoading(false);
      dispatch(hideLoading());
    }
  };

  const handleDefaultBenchmark = async () => {
    handleLoading(true);
    let url = 'veregy_benchmarking/default_benchmark';
    let payload = { 'resource_type': resourceOption2, 'resource_id': resourceId2 }

    try {
      await new WebAPIClient().POST(url, payload);
      toastr.success({
        title: 'Benchmark(s) Created',
      });
    } catch (err) {
      errorResponseToastr(err);
    } finally {
      handleLoading(false);
      dispatch(hideLoading());
    }
  };

  return <div>
    <h3>Create Verified Organization</h3>
    <form>
      <List disablePadding>
        <ListItem disableGutters>
          <TextField
            fullWidth
            variant='standard'
            id='value'
            label={`Organization ID`}
            value={orgId ? orgId : ''}
            onChange={(e) => setOrgId(e.target.value)}
          />
        </ListItem>


        <Button
          type='submit'
          onClick={handleCreateOrg}
          color='primary'
          variant='contained'
          disabled={
            !orgId ||
            isLoading
          }>
          Submit
        </Button>
      </List>
    </form>


    <h3>Create Verified Buildings</h3>
    <form>
      <List disablePadding>
        <ListItem disableGutters>
          <FormControl id='resource' variant='standard' fullWidth>
            <InputLabel id='resource-label'>Resource Option</InputLabel>
            <Select
              labelId='resource-label'
              name='resource'
              onChange={(e) => {
                setResourceOption(e.target.value);
              }}
              value={resourceOption}
              MenuProps={{
                MenuListProps: { disablePadding: true },
                slotProps: {
                  paper: { sx: { minWidth: 'unset !important' } },
                },
              }}
              sx={{
                backgroundColor: 'unset',
                '& .MuiSelect-select': {
                  display: 'flex',
                  alignItems: 'center',
                },
              }}>
              <MenuItem value=''></MenuItem>
              <MenuItem key={'building'} value={'building'}>
                Single Building
              </MenuItem>
              <MenuItem key={'organization_buildings'} value={'organization_buildings'}>
                All Org Buildings
              </MenuItem>
            </Select>
          </FormControl>
        </ListItem>
        <ListItem disableGutters>
          <TextField
            fullWidth
            variant='standard'
            id='value'
            label={resourceOption === 'building' ? `Building ID` : `Organization ID`}
            value={resourceId ? resourceId : ''}
            onChange={(e) => setResourceId(e.target.value)}
          />
        </ListItem>


        <Button
          type='submit'
          onClick={handleCreateResource}
          color='primary'
          variant='contained'
          disabled={
            !resourceId ||
            isLoading
          }>
          Submit
        </Button>
      </List>
    </form>

    <h3>Generate Default Benchmarks</h3>
    <form>
      <List disablePadding>
        <ListItem disableGutters>
          <FormControl id='resource2' variant='standard' fullWidth>
            <InputLabel id='resource2-label'>Resource Option</InputLabel>
            <Select
              labelId='resource2-label'
              name='resource2'
              onChange={(e) => {
                setResourceOption2(e.target.value);
              }}
              value={resourceOption2}
              MenuProps={{
                MenuListProps: { disablePadding: true },
                slotProps: {
                  paper: { sx: { minWidth: 'unset !important' } },
                },
              }}
              sx={{
                backgroundColor: 'unset',
                '& .MuiSelect-select': {
                  display: 'flex',
                  alignItems: 'center',
                },
              }}>
              <MenuItem value=''></MenuItem>
              <MenuItem key={'building'} value={'building'}>
                Single Building
              </MenuItem>
              <MenuItem key={'organization_buildings'} value={'organization_buildings'}>
                All Org Buildings
              </MenuItem>
            </Select>
          </FormControl>
        </ListItem>
        <ListItem disableGutters>
          <TextField
            fullWidth
            variant='standard'
            id='value'
            label={resourceOption2 === 'building' ? `Building ID` : `Organization ID`}
            value={resourceId2 ? resourceId2 : ''}
            onChange={(e) => setResourceId2(e.target.value)}
          />
        </ListItem>


        <Button
          type='submit'
          onClick={handleDefaultBenchmark}
          color='primary'
          variant='contained'
          disabled={
            !resourceId2 ||
            isLoading
          }>
          Submit
        </Button>
      </List>
    </form>
  </div>
}